import { render, staticRenderFns } from "./config-search.vue?vue&type=template&id=3263fc3e&"
import script from "./config-search.vue?vue&type=script&lang=js&"
export * from "./config-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports